import React from 'react';
import Radio from '../../../../../core/components/inputs/radio/Radio';
import styles from './RadioContainer.module.scss';

function RadioContainer(props) {
    return (
        <div
            className={`${styles.radio} ${
                `${props.formik.values.flagValidacao}`.trim() === `${props.value}`
                    ? styles.checked
                    : ''
            }`}
        >
            <Radio name="flagValidacao" {...props} />
        </div>
    );
}

export default RadioContainer;
